import { create } from 'zustand';
import type { CastMember } from '@/staging/casting.ts';

interface BlockingState {
  castCatalog: CastMember[];
  setCastCatalog: (members: CastMember[]) => void;
}

export const useBlockingStore = create<BlockingState>((set) => ({
  castCatalog: [],
  setCastCatalog: (members) => set({ castCatalog: members }),
}));
